import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ITicket, ITicketRequest } from "../types/Types";

/**
 * @author mb
 */
export const TicketAPI = createApi({
    reducerPath: "ticketAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "ticket",
            credentials: 'include'
        }),
    tagTypes: ['ticketAPI'], // for caching
    endpoints: (builder) => ({
        getTicketListe: builder.mutation<ITicket[], void>(
            {
                query: () => ({
                    url: '/',
                    method: 'get',
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        getTicket: builder.mutation<any, string>(
            {
                query: (uid) => ({
                    url: '/' + uid,
                    method: 'get',
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        createOrUpdateTicket: builder.mutation<ITicket, ITicketRequest>(
            {
                query: (dto: ITicketRequest) => ({
                    url: 'createOrUpdate',
                    method: 'put',
                    credentials: 'include',
                    body: dto
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        deleteTicket: builder.mutation<ITicket, string>(
            {
                query: (uid) => ({
                    url: '' + uid,
                    method: 'delete',
                    params: {
                    },
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        getTicketNachrichten: builder.mutation<any, string>(
            {
                query: (uid) => ({
                    url: '/' + uid + "/nachrichten/",
                    method: 'get',
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        newTicketNachricht: builder.mutation<string, {uid: string, text: string}>(
            {
                query: (dto) => ({
                    url: '/' + dto.uid + '/nachrichten/',
                    method: 'put',
                    body: dto.text,
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),

    })
});

export const {

    useGetTicketListeMutation,
    useCreateOrUpdateTicketMutation,
    useGetTicketMutation,
    useDeleteTicketMutation,
    useGetTicketNachrichtenMutation,
    useNewTicketNachrichtMutation,

} = TicketAPI;
